// Cart suggestions: Shopify recommendations seeded by the last product added,
// cart products excluded, rebuilt on every cart change. Cards come through the
// Section Rendering API, so they are full catalogue cards with quick-add.
(function () {
  const bq = window.bq;
  if (!bq) return;

  // Roots already wired, each with its own debounced rebuild.
  const roots = new Map();

  function init(root) {
    if (!root || roots.has(root)) return;
    const grid = root.querySelector('[data-bq-suggest-grid]');
    if (!grid) return;
    const maxCards = Number(root.dataset.max) || 4;
    // Locale prefix: an unprefixed fetch answers in the shop's primary language.
    const routeRoot = bq.root(root);
    let seq = 0;
    let timer = null;

    // Shimmer skeleton, first load only: no flash on updates, where real cards
    // are already in place.
    function showSkeleton(n) {
      if (grid.querySelector('product-card')) return;
      let html = '';
      for (let i = 0; i < n; i++) {
        html +=
          '<div class="bq-suggest-skel" aria-hidden="true">' +
          '<div class="bq-suggest-skel__img"></div>' +
          '<div class="bq-suggest-skel__line bq-suggest-skel__line--name"></div>' +
          '<div class="bq-suggest-skel__line bq-suggest-skel__line--price"></div>' +
          '</div>';
      }
      grid.innerHTML = html;
      root.hidden = false;
    }

    function paint(parts) {
      grid.innerHTML = parts.join('');
      const cards = grid.children;
      for (let i = 0; i < cards.length; i++) {
        cards[i].style.setProperty('--i', i);
        cards[i].classList.add('bq-suggest-in');
      }
      root.hidden = false;
    }

    // Server-rendered card: the custom elements (product-card, quick-add-component)
    // hydrate on injection wherever they are already registered.
    function fetchCard(p) {
      const url = (p.url || '').split('?')[0] + '?section_id=bq-suggest-card';
      return fetch(url)
        .then(function (r) {
          return r.ok ? r.text() : null;
        })
        .then(function (html) {
          if (!html) return null;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('product-card');
          return card ? card.outerHTML : null;
        })
        .catch(function () {
          return null;
        });
    }

    function rebuild() {
      const mine = ++seq;
      fetch(routeRoot + 'cart.js', { headers: { accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (mine !== seq) return null;
          if (!cart.items.length) {
            root.hidden = true;
            return null;
          }
          showSkeleton(maxCards);
          const inCart = {};
          cart.items.forEach(function (it) {
            inCart[it.product_id] = true;
          });
          // One seed, the last line added: more seeds cost a round-trip each for
          // a list the shopper reads as one, and newest intent predicts best.
          const seed = cart.items[cart.items.length - 1].product_id;
          return fetch(
            routeRoot + 'recommendations/products.json?product_id=' + seed + '&limit=10&intent=related'
          )
            .then(function (r) {
              return r.ok ? r.json() : { products: [] };
            })
            .catch(function () {
              return { products: [] };
            })
            .then(function (list) {
              if (mine !== seq) return;
              const picked = [];
              (list.products || []).forEach(function (p) {
                if (picked.length >= maxCards || inCart[p.id]) return;
                picked.push(p);
              });
              if (!picked.length) {
                root.hidden = true;
                return;
              }
              return Promise.all(picked.map(fetchCard)).then(function (htmls) {
                if (mine !== seq) return;
                const parts = htmls.filter(Boolean);
                if (!parts.length) {
                  root.hidden = true;
                  return;
                }
                paint(parts);
              });
            });
        })
        .catch(function () {});
    }

    // Coalesce add bursts into one rebuild; the seq token still guarantees only
    // the latest cart state paints.
    function schedule() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        rebuild();
      }, 250);
    }

    roots.set(root, schedule);

    // The gate is the parent, never the band: the band starts hidden, so watching
    // it would wait for a paint only this build can cause.
    const gate = root.parentElement || root;
    if (gate.getClientRects().length || typeof IntersectionObserver !== 'function') {
      rebuild();
    } else {
      const io = new IntersectionObserver(function (entries) {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        rebuild();
      });
      io.observe(gate);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bq-suggest]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:cart:lines-update', function (event) {
    const run = function () {
      // A section re-render brings a fresh root; a detached one steps aside.
      initAll();
      roots.forEach(function (schedule, root) {
        if (root.isConnected) schedule();
        else roots.delete(root);
      });
    };
    // Optimistic event: await the request promise or the read returns the stale
    // cart. It sits on the event, not on `detail`, which is undefined.
    const p = event && (event.promise || (event.detail && event.detail.promise));
    if (p && typeof p.finally === 'function') p.finally(run);
    else setTimeout(run, 400);
  });
})();
